<template>
  <div class="ac-card-content">
    <div class="ac-body-container">
      <div class="sac__font-24 med">Promo Wizard Help</div>
      <div class="sac__font-16 med margin-top-8">Delivered, Viewed and Clicks</div>
      <div class="ac-plan-info-container margin-top-16">
        <div>
          <div class="sac__font-16 n90 center">Delivered</div>
          <div class="sac__font-12 n90 left">
            <div>
              This shows the total number of
              <span class="sac__font-12 n90 semi-bold"
                >members eligible to receive the notification</span
              >
              and the total members registered in the selected plans.
            </div>
            <div class="mt-2">
              The notification was not sent because these members have reached their limit per
              quarter/year.
            </div>
          </div>
        </div>
        <div class="margin-top-16">
          <div class="sac__font-16 n90 center">Viewed</div>
          <div class="sac__font-12 n90">
            Number of members who <span class="sac__font-12 n90 semi-bold">opened</span> the Promo
            Offers details page.
          </div>
        </div>
        <div class="margin-top-16">
          <div class="sac__font-16 n90 center">Clicks</div>
          <div class="sac__font-12 n90 left">
            Number of members who <span class="sac__font-12 n90 semi-bold">click the CTA</span> on
            the Promo Offer details page.
          </div>
        </div>
      </div>
      <div class="ac-button-container">
        <button type="button" class="ac-button" @click="close">Close</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PromoAdditionalInfo',
  props: {
    close: Function,
    openBuilder: Function,
  },
};
</script>
